import {get, post} from './apiMethods';
import fetch from 'node-fetch';

export const data_source = {
  fetch : () => get('api/data-source')
};

export const unit = {
  fetch : () => get('api/unit')
};

export const postData = payload => fetch(`https://${window.localStorage.tss_url}/import`, {method: 'POST', body: JSON.stringify(payload), headers: {Accept: 'application/json', 'Content-Type': 'application/json'}});



// WEBPACK FOOTER //
// ./src/libs/api.js